import safeJsonParse, { JsonValue } from '../../lib/safe-json-parse/safe-json-parse'

const storage = {
    getItem: <T extends JsonValue>(key: string): T | null => {
        return safeJsonParse<T>(window.localStorage.getItem(key))
    },
    setItem: (key: string, value: unknown): void => {
        window.localStorage.setItem(key, JSON.stringify(value))
    },
    removeItem: (key: string): void => {
        window.localStorage.removeItem(key)
    },
}

export default storage
